import { PROFILE_FEED_TAB_KEYS } from '~/utils/profile-feed-tab-keys';

// Profile
export const contentStep = (state) => state.contentStep;
export const profile = (state) => state.profile;
export const profileLoading = (state) => state.profileLoading;
export const profileError = (state) => state.profileError;
export const showProfileEditModal = (state) => state.showProfileEditModal;
export const createProfileRes = (state) => state.createProfile;
export const hasSeenWTPModalRes = (state) => state.hasSeenWTPModal;
export const deleteProfileRes = (state) => state.deleteProfile;

// Profile Feed
export const feed = (state) => state.feed;
export const feedLoading = (state) => state.feedLoading;
export const feedError = (state) => state.feedError;
export const postFeed = (state) => state.postFeed;
export const postFeedLoading = (state) => state.postFeedLoading;
export const postFeedError = (state) => state.postFeedError;
export const repliesFeed = (state) => state.repliesFeed;
export const repliesFeedLoading = (state) => state.repliesFeedLoading;
export const repliesFeedError = (state) => state.repliesFeedError;
export const nextPostLoading = (state) => state.nextPostLoading;
export const nextPostFeedLoading = (state) => state.nextPostFeedLoading;
export const nextRepliesFeedLoading = (state) => state.nextRepliesFeedLoading;
export const deleteUserPost = (state) => state.deleteUserPost;
export const feedTabs = (state) => state.feedTabs;
export const activeFeedTab = (state) => state.activeFeedTab;
export const profilePostFeedTabActive = (state) =>
  state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS;
export const profileRepliesFeedTabActive = (state) =>
  state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES;

// Profile Followers
export const followers = (state) => state.followers;
export const followersLoading = (state) => state.followersLoading;
export const nextFollowersLoading = (state) => state.nextFollowersLoading;
export const followersError = (state) => state.followersError;
export const showLoadMoreFollowers = (state) => state.showLoadMoreFollowers;

// Profile Followed
export const followed = (state) => state.followed;
export const followedLoading = (state) => state.followedLoading;
export const nextFollowedLoading = (state) => state.nextFollowedLoading;
export const followedError = (state) => state.followedError;
export const showLoadMoreFollowed = (state) => state.showLoadMoreFollowed;
export const profileFollowedCountPerTypeRes = (state) =>
  state.followedCountPerType;
